module.exports = __webpack_public_path__ + "img/WMS_scenario.ed3c1588.png";